export enum VocabTrainingTitleTags {
    BASED_ON_VOCAB = "BASED_ON_VOCAB",
    TODAYS_DATE = "TODAYS_DATE",
    BASED_ON_BOOK = "BASED_ON_BOOK",
}
